// Local part: RFC 5322 atext, dot-separated (no leading/trailing/consecutive dots).
// Domain: dot-separated LDH labels ending in an alphabetic TLD of 2+ chars.
const EMAIL_REGEX =
    /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/

// RFC 5321 size limits
const MAX_LOCAL_PART_LENGTH = 64
const MAX_EMAIL_LENGTH = 254

/**
 * Single source of truth for email format checks across the app.
 */
export function isValidEmail(value: string): boolean {
    if (value.length > MAX_EMAIL_LENGTH) {
        return false
    }
    if (!EMAIL_REGEX.test(value)) {
        return false
    }
    // Regex guarantees exactly one '@', so the first segment is the local part
    const localPart = value.slice(0, value.indexOf('@'))
    return localPart.length <= MAX_LOCAL_PART_LENGTH
}
